module.exports = __webpack_public_path__ + "static/flesje-434a3d3187a83ac9c01fc7fa758b08f4.png";